/**
 * Returns the global `window` object. Only defined on the client, returns null on the server.
 */
export function getWindow(): Window | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  return window
}

/**
 * Returns the global `process` object. Only defined on the server, returns null on the client.
 */
export function getProcess(): NodeJS.Process | undefined {
  if (typeof process === 'undefined') {
    return undefined
  }

  return process
}
